/* eslint-disable react/no-danger */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { store } from 'react-notifications-component';

export const showAlert = ({ message, type, onClick, blockAutoDismiss, showIcon }) => {
  const icons = {
    info: 'icon-info-icon',
    warning: 'icon-attention-other',
    danger: 'icon-cancel-icon',
    success: 'icon-done-status',
  };

  store.addNotification({
    message,
    type,
    dismiss: {
      duration: blockAutoDismiss ? 0 : 4000,
    },
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    content: (
      <div className="w-100" onClick={onClick} role="button" tabIndex={-1} onKeyDown={null}>
        <div className={`alert alert-${type}`} role="alert">
          <i className={`icon ${icons[type]}`} />
          <span className="content" dangerouslySetInnerHTML={{ __html: message }} />
          {showIcon && (
            <i
              className="icon icon-close-other text-shadow ms-3"
              onClick={onClick}
              onKeyDown={onClick}
              tabIndex={-1}
              role="button"
              aria-label="Close"
            />
          )}
        </div>
      </div>
    ),
  });
};

showAlert.defaultProps = {
  showIcon: false,
};
